import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.scss";
import './index.scss';
import { Landing } from "./Landing/Landing";
import Loader from "./Loader";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import "wow.js/css/libs/animate.css";
import WOW from "wow.js";
import './i18n';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate content loading delay (remove this in production)
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the delay as needed

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <LanguageProvider>
      <Router>
        {loading ? (
          <Loader /> // Show the loader while content is loading
        ) : (
          <div className="App">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
          </div>
        )}
      </Router>
    </LanguageProvider>
  );
}

export default App;
